import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "styles/colors.scss";
import "./global.scss";

import UserApp from "apps/user";

import React from "react";
import { BrowserRouter } from "react-router-dom";
import { I18nextProvider } from "react-i18next";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import AuthProvider from "providers/auth";
import ApolloClientProvider from "providers/apollo-client";
import ErrorBoundary from "./pages/common/ErrorBoundary";
import { useMobileView } from "./utility/useMobileView";
import ScrollToTop from "./utility/scroll-to-top";

import PatternBackgroundProvider from "./providers/pattern-background";
import i18n from "lib/i18n";
import LocaleSync from "lib/i18n/LocaleSync";
import DesktopIntegration from "desktop/DesktopIntegration";

// Note: Default behavirour of most browsers is to scroll to the previous scroll position
// when navigating back. This is not the desired behaviour for this app.
// window.history.scrollRestoration = "manual";

function App() {
  const { isMobileBrowser, MobileView } = useMobileView();
  const notShowMobileViewOnCreateCompany =
    window.location.pathname === "/signup/company" ||
    window.location.pathname === "/signup/company/invalid-link";

  const app =
    isMobileBrowser && !notShowMobileViewOnCreateCompany ? (
      <MobileView />
    ) : (
      <UserApp />
    );

  return (
    <ErrorBoundary>
      <I18nextProvider i18n={i18n}>
        <BrowserRouter>
          <ScrollToTop />
          <ApolloClientProvider>
            <AuthProvider>
              <LocaleSync />
              <DesktopIntegration />
              <ToastContainer theme="dark" />
              <PatternBackgroundProvider>{app}</PatternBackgroundProvider>
            </AuthProvider>
          </ApolloClientProvider>
        </BrowserRouter>
      </I18nextProvider>
    </ErrorBoundary>
  );
}

export default App;
